export default {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
}
